import { render, staticRenderFns } from "./ChannelGroupPermissions.vue?vue&type=template&id=faf4cf94"
import script from "./ChannelGroupPermissions.vue?vue&type=script&lang=js"
export * from "./ChannelGroupPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports